export const splitPartnumbers = (values: string[]): string[] => {
  const expanded = values
    .flatMap((value) => value.split(/[\s,]+/))
    .map((value) => value.trim())
    .filter(Boolean);

  return Array.from(new Set(expanded));
};

export default splitPartnumbers;
